import React, { ReactElement } from 'react';
import { Button, Flex, Text, VStack } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { CloseIcon } from 'assets/icons/v2';
import { CustomModal } from 'components/common/Modal/CustomModal';
import { CustomModalContent } from 'components/common/Modal/CustomModalContent';

type Props = {
  isOpen: boolean;
  offsetLeft?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const RemoveConfirmationModal = ({
  isOpen,
  offsetLeft,
  onConfirm,
  onCancel,
}: Props): ReactElement => {
  return (
    <CustomModal isOpen={isOpen} onClose={onCancel} placement="center" hideHeader size="sm">
      <CustomModalContent p="30px">
        <Flex direction="column" gap="30px">
          <Flex direction="column" align="flex-end" gap="5px">
            <NovaIconButton
              aria-label="Schließen"
              variant="primary"
              size="l"
              onClick={onCancel}
              minW="24px"
              h="24px"
              p={0}
              icon={CloseIcon}
              iconProps={{ w: '24px', h: '24px', color: 'text.primary' }}
            />
            <VStack gap="15px" align="flex-start" w="full">
              <Text textStyle="h4.medium" color="text.primary">
                Arbeitsblatt aus Kurs entfernen
              </Text>
              <Text textStyle="body.m.regular" color="text.primary">
                Möchtest du das Arbeitsblatt wirklich aus diesem Kurs entfernen?
              </Text>
              <Text textStyle="body.m.regular" color="text.primary">
                <b>Hinweis: </b> <br />
                Die Antworten der Lernenden in diesem Kurs werden gelöscht.
              </Text>
            </VStack>
          </Flex>

          <Flex gap="l" justify="flex-end">
            <Button onClick={onCancel} variant="tertiary">
              <Text textStyle="body.m.regular" color="text.secondary">
                Abbrechen
              </Text>
            </Button>
            <Button onClick={onConfirm} variant="destructive">
              Entfernen
            </Button>
          </Flex>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
